

















import { Vue, Component } from "vue-property-decorator";
import ResizeObserver from "@/components/ResizeObserver.vue";
import { $store } from "./store";

@Component({
  components: {
    ResizeObserver,
  },
})
export default class App extends Vue {
  get overlay() {
    return $store.appearance.overlay;
  }

  async mounted() {
    this.$el.classList.add("no-whitelabel");
  }

  handleResize(evt: { width: number; height: number }) {
    $store.appearance.currentWidth = Math.round(evt.width);
    $store.appearance.currentHeight = Math.round(evt.height);
  }
}
